import { render, staticRenderFns } from "./myIndex.vue?vue&type=template&id=cb6a0082&scoped=true&"
import script from "./myIndex.vue?vue&type=script&lang=js&"
export * from "./myIndex.vue?vue&type=script&lang=js&"
import style0 from "./myIndex.vue?vue&type=style&index=0&id=cb6a0082&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6a0082",
  null
  
)

export default component.exports